/**
 * Integrytas Group — Record Extensions: filter-bar drop-in.
 *
 * Renders one <FacetFilter> per facet-flagged manifest field (§17.B5). Drop into
 * a host list page's toolbar:
 *
 *   const ext = useRecordExtensions(PAGE_CODE, { pkColumn: 'user_id' });
 *   ...<ExtensionFacets ext={ext} />
 *
 * and combine ext.matchRow(row) into the page's `filtered` memo. Renders nothing
 * until an app registers an extension, so it is safe to add unconditionally.
 */

import { FacetFilter } from './FacetFilter';
import type { UseRecordExtensions } from '../../hooks/use_record_extensions';

export function ExtensionFacets({ ext }: { ext: UseRecordExtensions }) {
  if (ext.facets.length === 0) return null;
  return (
    <>
      {ext.facets.map(f => (
        <FacetFilter
          key={f.key}
          label={f.label}
          options={f.options}
          selected={ext.filterValues[f.key] ?? []}
          onChange={v => ext.setFilter(f.key, v)}
        />
      ))}
    </>
  );
}
